exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "#pufferfish .campaign-list .page-header-right{text-align:right}", ""]);
